<template>
  <base-card>
    <v-card-text>
      <div class="d-flex justify-space-between align-center flex-wrap">
        <div class="py-4">
          <div class="card-title mb-0 font-weight-bolder" style="font-size: 1.5rem;">
            {{ t("available_withdrawal", { amount: availableWithdrawal }) }}

            <v-btn icon x-small color="blue" @click="openDetails">
              <v-icon>mdi-help-circle</v-icon>
            </v-btn>
          </div>
        </div>

        <new-request />
      </div>
      <div v-show="userExtraInfoVisible">
        <div v-if="!holdInfo">{{ $t("common.loading") }}</div>
        <div v-else>
          <span class="font-weight-bold">{{ t("amount_in_hold") }}: {{ holdInfo.sum }} USD</span>
          <router-link class="text-small" :to="{ name: 'faq', hash: '#61' }"> ({{ t("what_is_hold") }})</router-link>
          <br />

          {{ t("files") }}:
          <template v-if="holdInfo.premium.length > 0">
            <template v-for="item in holdInfo.premium">
              <span style="text-transform: capitalize">{{ appDomain(item.apptype) }}</span> -

              <span class="mr-2">
                <router-link :to="{ name: 'stats.sales', params: { app: item.apptype }, query: { type: 'files' } }">
                  {{ item.amount }} USD</router-link
                ><span v-if="holdInfo.premium.length === 2 && item.apptype === 'fd1'">,</span>
              </span>
            </template>
          </template>

          <template v-else>0 USD</template>
          <br />

          {{ t("referrals") }}: {{ holdInfo.referrals }} USD
          <br />

          {{ t("sites_referrals") }}:
          <template v-if="holdInfo.sites.length > 0">
            <template v-for="item in holdInfo.sites">
              <span style="text-transform: capitalize">{{ appDomain(item.apptype) }}</span> -

              <span class="mr-2">
                <router-link :to="{ name: 'stats.sales', params: { app: item.apptype }, query: { type: 'sites' } }">
                  {{ item.amount }} USD</router-link
                ><span v-if="holdInfo.sites.length === 2 && item.apptype === 'fd1'">,</span>
              </span>
            </template>
          </template>
          <template v-else>0 USD</template>
          <br />

          {{ t("file_copies") }}:
          <template v-if="holdInfo.copies.length > 0">
            <template v-for="item in holdInfo.copies">
              <router-link class="mr-2" :to="{ path: '/user/transactions' }" target="_blank">
                {{ item.amount }} USD
              </router-link>
            </template>
          </template>
          <template v-else>0 USD</template>
        </div>
      </div>
    </v-card-text>
  </base-card>
</template>

<script>
import NewRequest from "@/views/pages/payouts/request-payout/NewRequest";

export default {
  components: { NewRequest },
  data() {
    return {
      userExtraInfoVisible: false
    };
  },
  computed: {
    availableWithdrawal() {
      return this.$store.state.payouts.availableWithdrawal;
    },
    holdInfo() {
      return this.$store.state.payouts.holdInfo;
    },
    userPurses() {
      return this.$store.state.payouts.purses;
    },
    purseTypes() {
      return this.$store.state.payouts.pursesTypes;
    }
  },
  methods: {
    openDetails() {
      this.userExtraInfoVisible = !this.userExtraInfoVisible;

      if (this.userExtraInfoVisible && !this.holdInfo) {
        this.$store.dispatch("payouts/loadHoldInfo");
      }
    },

    appDomain(apptype) {
      if (!this.$store.state.app.appData[apptype]) {
        return "";
      }

      return this.$store.state.app.appData[apptype].domain;
    },

    t(key, params) {
      return this.$t("pages.payouts." + key, params);
    }
  }
};
</script>
